import { gspx } from '@rsos/gainsight';

export const trackClickOnSuggestedLocation = (
  irpVersion,
  gisSource,
  gisType,
) => {
  gspx.trackCustomEvent('Data Jurisdiction', {
    irpVersion,
    name: 'Select GIS Search Result',
    Category: 'GIS Search',
    'Launched date': new Date(),
    gisSource,
    gisType,
  });
};
